'use client';

import { c as _c } from "react/compiler-runtime";
import { CustomError } from '@core/utils';
import { useShallow } from 'zustand/react/shallow';
import { DEFAULT_LOCATION } from '@/constants/geo';
import { useCustomRouter } from '@/hooks/useCustomRouter';
import { useAuthStore } from '@/stores/AuthStore';
import { FeedList } from './FeedList';
import { FeedRegionBar } from './FeedRegionBar';
interface FeedSectionProps {
  isGuest: boolean;
  codeRegion?: string;
  codeSubRegion?: string;
}
export const FeedSection = t0 => {
  const $ = _c(19);
  const {
    isGuest,
    codeRegion,
    codeSubRegion
  } = t0;
  let t1;
  if ($[0] !== codeRegion || $[1] !== codeSubRegion) {
    t1 = t2 => {
      const {
        region,
        myInfo
      } = t2;
      return [codeRegion || region?.at(0)?.codeRegion || myInfo?.codeRegion || DEFAULT_LOCATION.codeRegion, codeSubRegion || region?.at(0)?.codeSubRegion || myInfo?.codeSubRegion || DEFAULT_LOCATION.codeSubRegion];
    };
    $[0] = codeRegion;
    $[1] = codeSubRegion;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const [selectedCodeRegion, selectedCodeSubRegion] = useAuthStore(useShallow(t1));
  const router = useCustomRouter();
  let t2;
  if ($[3] !== selectedCodeRegion || $[4] !== selectedCodeSubRegion) {
    t2 = {
      mainRegionCode: selectedCodeRegion,
      subRegionCode: selectedCodeSubRegion
    };
    $[3] = selectedCodeRegion;
    $[4] = selectedCodeSubRegion;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== router || $[7] !== selectedCodeSubRegion) {
    t3 = t4 => {
      const {
        mainRegion,
        subRegion
      } = t4;
      if (!mainRegion.code || !subRegion.code) {
        throw new CustomError({
          return_message: "\uC9C0\uC5ED \uB370\uC774\uD130\uAC00 \uC62C\uBC14\uB974\uC9C0 \uC54A\uC2B5\uB2C8\uB2E4."
        });
      }
      if (subRegion.code === selectedCodeSubRegion) {
        return;
      }
      const params = new URLSearchParams(window.location.search);
      params.set("codeRegion", mainRegion.code);
      params.set("codeSubRegion", subRegion.code);
      router.replace(`?${params.toString()}`);
    };
    $[6] = router;
    $[7] = selectedCodeSubRegion;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== t2 || $[10] !== t3) {
    t4 = <FeedRegionBar value={t2} onChange={t3} />;
    $[9] = t2;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== isGuest || $[13] !== selectedCodeRegion || $[14] !== selectedCodeSubRegion) {
    t5 = <FeedList isGuest={isGuest} codeRegion={selectedCodeRegion} codeSubRegion={selectedCodeSubRegion} />;
    $[12] = isGuest;
    $[13] = selectedCodeRegion;
    $[14] = selectedCodeSubRegion;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  let t6;
  if ($[16] !== t4 || $[17] !== t5) {
    t6 = <section className="flex flex-col bg-Gray-white xl:bg-transparent">{t4}{t5}</section>;
    $[16] = t4;
    $[17] = t5;
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  return t6;
};